import { FC, PropsWithChildren } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const sharedMotionProps = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: 'auto' },
  exit: { opacity: 0, height: 0 },
  transition: { duration: 0.3, ease: 'easeInOut' }
};
export const NftCartItemAnimatedContainer: FC<PropsWithChildren> = ({
  children
}) => {
  return (
    <motion.div
      layout
      style={{ gridColumn: '1 / -1', overflow: 'hidden', width: '100%' }}
      {...sharedMotionProps}
    >
      {children}
    </motion.div>
  );
};
